import React, { ReactNode } from 'react';
import IconButtonMUI from '@mui/material/IconButton';

type IconButtonProps = {
  onClick: () => void;
  icon: ReactNode;
};

export const IconButton = ({
  onClick,
  icon,
}: IconButtonProps) => {
  return (
    <IconButtonMUI
      type="button"
      onClick={onClick}
      size="small"
      sx={{
        width: 36,
        height: 36,
        borderRadius: '8px',
        bgcolor: 'background.paper',
        color: 'text.primary',
        border: '1px solid',
        borderColor: 'divider',
        '&:hover': {
          bgcolor: 'primary.50',
          borderColor: 'primary.main',
          color: 'primary.main',
        },
        '& svg': {
          width: 18,
          height: 18,
        },
      }}
    >
      {icon}
    </IconButtonMUI>
  );
};
